import { types } from 'actions/lists';
import { toggleSelection } from 'components/common/Table/MultiSelect/helpers';
import { views } from 'components/Lists/constants';

let defaultState = {
  view: views.researchers,
  modal: '',
  researcher: {
    activeList: {},
    addToTarget: {},
    showMyListsOnly: false,
    includePausedLists: false,
    pageSize: 50,
    pageNumber: 0,
    search: '',
    selectedMembers: {
      include: {},
      exclude: {},
    },
    tableSort: {
      dir: 'desc',
      by: 'dateAddedUtc',
    },
    listMembers: {},
    restoringState: true,
    exportExtraParams: null,
    loading: false,
    listsPageSize: 20,
    listsPageNumber: 0,
    listsTableSort: {
      dir: 'desc',
      by: 'dateCreatedUtc',
    },
    listsSearch: '',
    selectedLists: {
      include: {},
      exclude: {},
    },
  },
  organisation: {
    activeList: {},
    addToTarget: {},
    showMyListsOnly: false,
    includePausedLists: false,
    pageSize: 50,
    pageNumber: 0,
    search: '',
    selectedMembers: {
      include: {},
      exclude: {},
    },
    tableSort: {
      dir: 'desc',
      by: 'dateAddedUtc',
    },
    listMembers: {},
    restoringState: true,
    exportExtraParams: null,
    loading: false,
    listsPageSize: 20,
    listsPageNumber: 0,
    listsTableSort: {
      dir: 'desc',
      by: 'dateCreatedUtc',
    },
    listsSearch: '',
    selectedLists: {
      include: {},
      exclude: {},
    },
  },
};

const baseReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_VIEW:
      return {
        ...state,
        view: action.payload,
      };
    case types.SET_MODAL:
      return {
        ...state,
        modal: action.payload.modal,
      };
    case types.RESTORE_STATE: {
      if (!action.payload) {
        return {
          ...state,
          restoringState: false,
        };
      }

      const restoredState = JSON.parse(JSON.stringify(action.payload));
      restoredState.restoringState = false;
      delete restoredState.researcher?.selectedMembers?.all;
      delete restoredState.organisation?.selectedMembers?.all;
      return {
        ...defaultState,
        ...restoredState,
        researcher: { ...defaultState.researcher, ...restoredState.researcher },
        organisation: {
          ...defaultState.organisation,
          ...restoredState.organisation,
        },
      };
    }
    default:
      return state;
  }
};

const REDUCER = {
  [types.SET_ACTIVE_LIST]: (state, action) => {
    if (!action.payload.list?.id) {
      return {
        ...state,
        activeList: action.payload.list,
        selectedMembers: { exclude: {}, include: {} },
        listMembers: {},
        pageSize: 50,
        pageNumber: 0,
      };
    }
    return {
      ...state,
      activeList: action.payload.list,
      pageSize: 50,
      pageNumber: 0,
    };
  },
  [types.SET_SHOW_MY_LISTS_ONLY]: (state, action) => ({
    ...state,
    showMyListsOnly: action.payload.show,
    listsPageNumber: 0,
    listsPageSize: 20,
  }),
  [types.SET_INCLUDE_PAUSED_LISTS]: (state, action) => ({
    ...state,
    includePausedLists: action.payload.include,
    listsPageNumber: 0,
    listsPageSize: 20,
  }),
  [types.SET_ONLY_ENRICHED]: (state, action) => ({
    ...state,
    onlyEnriched: action.payload.onlyEnriched,
    listsPageNumber: 0,
    listsPageSize: 20,
  }),
  [types.SET_SELECTED_MEMBERS]: (state, action) => ({
    ...state,
    selectedMembers: {
      ...action.payload.selected,
    },
  }),
  [types.SET_PAGE_SIZE]: (state, action) => ({
    ...state,
    pageSize: action.payload.size,
  }),
  [types.SET_PAGE_NUMBER]: (state, action) => ({
    ...state,
    pageNumber: action.payload.number,
  }),
  [types.SET_SORT]: (state, action) => {
    let sort = { ...state.tableSort };

    if (action.payload.sortKey === sort.by) {
      if (sort.dir === 'asc') {
        sort = {
          by: action.payload.sortKey,
          dir: 'desc',
        };
      } else {
        sort = {
          by: 'dateAddedUtc',
          dir: sort.by === 'dateAddedUtc' ? 'asc' : 'desc',
        };
      }
    } else {
      sort = {
        by: action.payload.sortKey,
        dir: 'asc',
      };
    }
    return {
      ...state,
      tableSort: sort,
    };
  },
  [types.SET_MEMBERS_SEARCH]: (state, action) => ({
    ...state,
    pageNumber: 0,
    search: action.payload,
  }),
  [types.SET_ADD_TO_TARGET]: (state, action) => ({
    ...state,
    addToTarget: action.payload.list,
  }),
  [types.SET_LIST_MEMBERS]: (state, action) => ({
    ...state,
    listMembers: { ...action.payload.members },
  }),
  [types.SET_EXPORT_EXTRA_PARAMS]: (state, action) => ({
    ...state,
    exportExtraParams: action.payload,
  }),
  [types.SET_LISTS_SORT]: (state, action) => {
    let sort = { ...state.listsTableSort };

    if (action.payload.sortKey === sort.by) {
      if (sort.dir === 'asc') {
        sort = {
          by: action.payload.sortKey,
          dir: 'desc',
        };
      } else {
        sort = {
          by: 'dateCreatedUtc',
          dir: sort.by === 'dateCreatedUtc' ? 'asc' : 'desc',
        };
      }
    } else {
      sort = {
        by: action.payload.sortKey,
        dir: 'asc',
      };
    }
    return {
      ...state,
      listsTableSort: sort,
    };
  },
  [types.SET_LISTS_PAGE_SIZE]: (state, action) => ({
    ...state,
    listsPageSize: action.payload.size,
  }),
  [types.SET_LISTS_PAGE_NUMBER]: (state, action) => ({
    ...state,
    listsPageNumber: action.payload.number,
  }),
  [types.SET_LISTS_SEARCH]: (state, action) => ({
    ...state,
    listsPageNumber: 0,
    listsSearch: action.payload,
  }),
  [types.TOGGLE_LISTS]: (state, action) => ({
    ...state,
    selectedLists: toggleSelection(state.selectedLists, action.payload),
  }),
  [types.TOGGLE_MEMBERS]: (state, action) => ({
    ...state,
    selectedMembers: toggleSelection(state.selectedMembers, action.payload),
  }),
  [types.RESET_SELECTED_LISTS]: state => ({
    ...state,
    selectedLists: {
      include: {},
      exclude: {},
    },
  }),
  [types.TOGGLE_ACTIVE_LIST]: (state, action) => ({
    ...state,
    activeList: {
      ...state.activeList,
      enabled: action.payload,
    },
  }),
  [types.SET_IS_LOADING]: (state, action) => ({
    ...state,
    loading: action.payload,
  }),
};

const reducer = (state = defaultState, action) => {
  let newState = baseReducer(state, action);
  const handler = REDUCER[action.type];
  const view = state.view;
  newState = {
    ...newState,
    [view]: handler ? handler(newState[view], action) : newState[view],
  };

  return newState;
};

export default reducer;
